<template>
  <div class="activity">
    <div class="activity-top">
      <DActivityAvatar :activity="activity" />

      <div class="activity-title">
        <DActivityAuthor :activity="activity" />

        <span>
          started following
          <DUserLinkPopup
            v-for="(user, index) in activity.extra.user_ids"
            :key="user.id"
            :user-id="user.id"
          >
            <template slot="content">
              <a
                class="resource-link"
                :href="user.url"
                :title="getUserFullName(user)"
              >
                {{ getUserFullName(user) }}<span
                  v-if="index !== activity.extra.user_ids.length - 1"
                  class="keep-spaces"
                >, </span>
              </a>
            </template>
          </DUserLinkPopup>
          <span v-if="isMoreThanThreeFollowers()"> and {{ moreFollowersAmount() }} more</span>
        </span>

        <DActivityTimestamp
          :activity="activity"
          class="visible-until-sm"
        />
      </div>

      <DActivityTimestamp
        :activity="activity"
        class="hidden-until-md"
      />
    </div>
  </div>
</template>

<script>
import activityMixin from '../shared/activity-mixin';
import DUserLinkPopup from '@d-components/d-user-link-popup/d-user-link-popup.vue';

export default {
  components: {
    DUserLinkPopup,
  },
  mixins: [
    activityMixin,
  ],
  methods: {
    isMoreThanThreeFollowers() {
      return this.activity.extra.total > 3;
    },
    moreFollowersAmount() {
      return this.activity.extra.total - this.activity.extra.user_ids.length;
    },
    getUserFullName(user) {
      return `${user.firstname} ${user.lastname}`;
    },
  },
};
</script>

